import List from './views/List.vue'
import CreateEdit from './views/CreateEdit.vue'
import Get from './views/Get.vue'

export const StatesRoutes = [
  {
    path: '/states',
    name: 'ListStates',
    component: List,
    meta: {
      auth: true,
      layout: 'home',
      permission: 'state:list'
    }
  },
  {
    path: '/state/',
    name: 'CreateState',
    component: CreateEdit,
    meta: {
      auth: true,
      layout: 'home',
      permission: 'state:create'
    }
  },
  {
    path: '/state/:id',
    name: 'UpdateState',
    component: CreateEdit,
    meta: {
      auth: true,
      layout: 'home',
      permission: 'state:update'
    }
  },
  {
    path: '/state/view/:id',
    name: 'GetState',
    component: Get,
    meta: {
      auth: true,
      layout: 'home',
      permission: 'state:get'
    }
  }
]
